// extracted by css-extract-rspack-plugin
export default {"list-item-cell":"u74f82","listItemCell":"u74f82","overflow-hidden":"NEU8iX","overflowHidden":"NEU8iX"};